(function ($) {
  var $slider = $(".slider__items");

  if ($slider.length) {
    var currentSlide;
    var slidesCount;
    var sliderCounter = document.createElement("div");
    sliderCounter.classList.add("slider__counter");

    var updateSliderCounter = function (slick, currentIndex) {
      currentSlide = slick.slickCurrentSlide() + 1;
      slidesCount = slick.slideCount;
      $(sliderCounter).text(currentSlide + "/" + slidesCount);
    };

    $slider.on("init", function (event, slick) {
      $slider.after(sliderCounter);
      updateSliderCounter(slick);
    });

    $slider.on("afterChange", function (event, slick, currentSlide) {
      updateSliderCounter(slick, currentSlide);
    });

    $slider.slick({
      autoplay: false,
      speed: 300,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      dots: false,
      appendArrows: $(".slider__controls"),
    });
  }
})(jQuery);
